// extracted by mini-css-extract-plugin
export default {"notes":"Notes_notes__d9sHw","toggle":"Notes_toggle__LP5bz","innerNotes":"Notes_innerNotes__jmNe-","button":"Notes_button__vejUq","active":"Notes_active__vhBxX"};